import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { AngularVelocity } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * The gyroscope provides on each reading the angular velocity of the device along all three axes.
 * @category data
 */
let Gyroscope = class Gyroscope extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new AngularVelocity(), frequency, displayName);
  }
};
Gyroscope = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, AngularVelocity, Number, String])], Gyroscope);
export { Gyroscope };